<template>
  <div>
    <transition name="fade">
      <!-- SPINNER -->
      <div
        v-if="locations.length === 0"
        class="flex items-center justify-center"
      >
        <SpinIcon class="mr-2 h-5 w-5 animate-spin text-second-blue-300" />
        <span class="text-sm">Loading locations...</span>
      </div>
      <!-- LOCATIONS -->
      <div v-else key="1" class="grid md:grid-cols-2 md:gap-12">
        <ul v-for="(halve, index) in halvedCountries" :key="index">
          <li
            v-for="country in halve"
            :key="country.id"
            class="-ml-3 mb-1 md:mb-5"
          >
            <Accordion :duration-open="300" hide-arrow>
              <template #summary>
                <div
                  class="flex w-full items-center gap-3 rounded-sm pl-3 pt-[0.375rem] transition-colors hover:bg-blue-50 md:pb-1"
                >
                  <img
                    loading="lazy"
                    class="w-5 md:w-6"
                    :src="country.country.flag?.permalink"
                  />
                  <h2 class="font-sans-heavy text-base md:text-lg">
                    {{ country.title }}
                  </h2>
                </div>
              </template>
              <template #content>
                <ul
                  class="mt-2 list-disc pl-11 text-md marker:text-main-blue md:pl-[3.0625rem]"
                >
                  <li
                    v-for="location in locations?.filter((location) => {
                      return location.parent?.id === country.id
                    })"
                    :key="location.id"
                    class="pb-1 md:pb-2"
                  >
                    <button
                      class="text-left text-sm md:text-base"
                      @click="$emit('focus-location', location)"
                    >
                      {{ location.title }}
                    </button>
                  </li>
                </ul>
              </template>
            </Accordion>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
const props = defineProps({
  countries: {
    type: Array,
    default: () => [],
  },
  locations: {
    type: Array,
    default: () => [],
  },
})

const halvedCountries = computed(() => {
  if (!props.countries.length) return []
  let middleIndex = Math.ceil(props.countries.length / 2)

  let firstHalf = props.countries.slice(0, middleIndex)
  let secondHalf = props.countries.slice(middleIndex)

  return [firstHalf, secondHalf]
})

defineEmits(['focus-location'])
</script>
